import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmStop = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" className="icon-llm-stop" width="1em" height="1em" data-icon="icon-llm-stop" aria-hidden="true" {...props} ref={ref}><path d="M200.73,40H55.27A15.29,15.29,0,0,0,40,55.27V200.73A15.29,15.29,0,0,0,55.27,216H200.73A15.29,15.29,0,0,0,216,200.73V55.27A15.29,15.29,0,0,0,200.73,40ZM200,200H56V56H200Z" fill="currentColor"/></svg>);
});

IconLlmStop.displayName = 'IconLlmStop';
